import type { ScheduledMeeting } from '../services/schedulingService';

/** Display a visit's actual booking mode; opening hours are not an arrival time. */
export const formatMeetingTime = (meeting: ScheduledMeeting): string =>
  meeting.booking_mode === 'open_day'
    ? `Sin hora fija · ${(meeting.visit_window_start || '').slice(0, 5)}–${(meeting.visit_window_end || '').slice(0, 5)}`
    : (meeting.meeting_time || '').slice(0, 5);
